<template>
  <div class="demo">
    <div class="row">
      <SjSearchInput
        v-model="value"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="small"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="middle"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="large"
        clearable
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="mini"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput v-model="value" disabled placeholder="请输入搜索内容" />
    </div>

    <div class="row">
      <SjSearchInput
        v-model="value"
        @search="handleSearch"
        placeholder="请输入搜索内容"
        :allowEmpty="false"
        theme="card"
      >
      </SjSearchInput>

      <SjSearchInput
        v-model="value"
        size="small"
        theme="card"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="middle"
        theme="card"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="large"
        theme="card"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="mini"
        theme="card"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        theme="card"
        disabled
        placeholder="请输入搜索内容"
      />
    </div>

    <div class="row">
      <SjSearchInput
        v-model="value"
        @search="handleSearch"
        clearable
        theme="lightborder"
        placeholder="请输入搜索内容"
      />

      <SjSearchInput
        v-model="value"
        size="small"
        theme="lightborder"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="middle"
        theme="lightborder"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="large"
        theme="lightborder"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="mini"
        theme="lightborder"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        theme="lightborder"
        disabled
        placeholder="请输入搜索内容"
      />
    </div>

    <div class="row darkbg">
      <SjSearchInput
        v-model="value"
        @search="handleSearch"
        theme="darkbg"
        placeholder="请输入搜索内容"
      />

      <SjSearchInput
        v-model="value"
        size="small"
        theme="darkbg"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="middle"
        theme="darkbg"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="large"
        theme="darkbg"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        size="mini"
        theme="darkbg"
        @search="handleSearch"
        placeholder="请输入搜索内容"
      />
      <SjSearchInput
        v-model="value"
        theme="darkbg"
        disabled
        placeholder="请输入搜索内容"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: null
    };
  },
  methods: {
    handleSearch() {
      alert(`search: ${this.value}`);
    }
  }
};
</script>

<style scoped lang="less">
.demo {
  .row {
    padding: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > * {
      width: 200px;
      margin-right: 10px;
    }
    &.darkbg {
      background-color: @color-available;
    }
  }
}
</style>
